// src/index.js
import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import { FileProvider } from './ContextAPI/FileContext';
import { DownloadsProvider } from './contexts/DownloadsContext';
import { UploadsProvider } from './contexts/UploadsContext';
import '@fortawesome/fontawesome-free/css/all.min.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

// The ResizeObserver-loop error is filtered out of the dev overlay in public/index.html.

ReactDOM.render(
  <FileProvider>
    <DownloadsProvider>
      <UploadsProvider>
        <App />
      </UploadsProvider>
    </DownloadsProvider>
  </FileProvider>,
  document.getElementById('root')
);

// Register the minimal service worker so the app is installable ("Add to
// Home Screen" / desktop Install). It caches nothing — see public/service-worker.js.
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register(`${process.env.PUBLIC_URL}/service-worker.js`)
      .catch((err) => console.warn('Service worker registration failed:', err));
  });
}
